module.exports = __webpack_public_path__ + "img/brienneimmo.d6c0f382.webp";